import { backendErrorsHandler } from '../../../utils/Notification/BackendErrorsHandler';

type ReportFetch = () => Promise<{ data: Blob }>;

export const handleOrderHistoryReportExport = async ({
  downloadExcel,
  fetchReport,
  filename
}: {
  downloadExcel: (fetchReport: ReportFetch, filename: string) => Promise<void | undefined>;
  fetchReport: ReportFetch;
  filename: string;
}): Promise<void> => {
  try {
    await downloadExcel(fetchReport, filename);
  } catch (error) {
    backendErrorsHandler(error, { showFallback: true });
  }
};
